import React, { Component, Fragment } from 'react';
import '../../../../form-text-and-image-field'
import { hasValue } from '../../../../../general/js/general-helpers';

class FormTextAndImageField extends Component {
    constructor(props) {
        super(props);
    }

    getTagStyle(){
        const { tag } = this.props;

        if(!hasValue(tag) || !hasValue(tag.title)){
            return null
        }
        const { backgroundColor, textColor } = tag;
        return hasValue(backgroundColor) || hasValue(textColor) 
                ? { backgroundColor: backgroundColor,  color: textColor}
                : { };
    }

    render() {
        const { formRef, imageSrc, tag, headerTitle, headerText } = this.props;
        const displayTag = hasValue(tag) && hasValue(tag.title);
        const inlineTagMessageStyle = displayTag ? this.getTagStyle() : {};

        return (
            <Fragment>
                <div ref={formRef} className="text-and-image-field">
                    <div className="text-and-image-field__inner">
                        <div className='text-and-image-field__image--wrapper'>
                            {
                                displayTag &&
                                <div className="text-and-image-field__tag-message text-and-image-field__tag-message--mobile" style={inlineTagMessageStyle}>
                                    {tag.title}
                                </div>
                            }
                            <div className='text-and-image-field__image--content'>
                                <div className="text-and-image-field__image" style={{ backgroundImage: `url(${imageSrc})` }}/>
                            </div>
                        </div>
                        
                        <div className="text-and-image-field__container">
                            <div className="text-and-image-field__content">
                                <div className="text-and-image-field__title--row">
                                {
                                    hasValue(headerTitle) &&
                                    <div className="text-and-image-field__title">{headerTitle}</div>
                                }
                                {
                                    displayTag &&
                                    <div className="text-and-image-field__tag-message text-and-image-field__tag-message--desktop" style={inlineTagMessageStyle}>
                                        {tag.title}
                                    </div>
                                }
                                </div>
                                {
                                    hasValue(headerText) && 
                                    <div className="text-and-image-field__text" dangerouslySetInnerHTML={{ __html: headerText }}/>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

FormTextAndImageField.propTypes = {
};

export default FormTextAndImageField;
